import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropdown", "loading"]
  static values = {
    delay: { type: Number, default: 300 },
    minLength: { type: Number, default: 2 },
  }

  connect() {
    this._timer = null
    this._outsideClickActive = false
    this._handleOutsideClick = (event) => {
      if (!this.element.contains(event.target)) this.#close()
    }
    this._handleFrameRender = () => {
      this.loadingTarget.classList.add("hidden")
      if (this.inputTarget.value.trim().length >= this.minLengthValue) {
        this.dropdownTarget.classList.remove("hidden")
        if (!this._outsideClickActive) {
          document.addEventListener("click", this._handleOutsideClick)
          this._outsideClickActive = true
        }
      }
    }
    this.dropdownTarget.addEventListener("turbo:frame-render", this._handleFrameRender)
  }

  disconnect() {
    clearTimeout(this._timer)
    this.dropdownTarget.removeEventListener("turbo:frame-render", this._handleFrameRender)
    document.removeEventListener("click", this._handleOutsideClick)
    this._outsideClickActive = false
  }

  search() {
    clearTimeout(this._timer)
    const query = this.inputTarget.value.trim()
    if (query.length < this.minLengthValue) {
      this.#close()
      return
    }
    this._timer = setTimeout(() => this.#submit(), this.delayValue)
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.#close()
      this.inputTarget.blur()
    }
  }

  #submit() {
    this.loadingTarget.classList.remove("hidden")
    this.element.querySelector("form").requestSubmit()
  }

  #close() {
    clearTimeout(this._timer)
    this.loadingTarget.classList.add("hidden")
    this.dropdownTarget.classList.add("hidden")
    document.removeEventListener("click", this._handleOutsideClick)
    this._outsideClickActive = false
  }
}
